import EventBus from '@/vue/EventBus';

const DIALOG_ID = 'holiday-search-dialog';

// The control that announces the popup: the opener itself when it is a button,
// otherwise the button inside it (the homepage search bar wraps one)
function controlFor(searchIcon: HTMLElement): HTMLElement | null {
  return searchIcon.matches('button, [role="button"]') ? searchIcon : searchIcon.querySelector('button');
}

function init(): void {
  const searchIcons = document.querySelectorAll<HTMLElement>('.js-search');
  if (searchIcons.length > 0) {
    const controls: HTMLElement[] = [];

    searchIcons.forEach(searchIcon => {
      searchIcon.addEventListener('click', () => {
        EventBus.emit('open-search-modal');
      });

      const control = controlFor(searchIcon);
      if (control) {
        control.setAttribute('aria-haspopup', 'dialog');
        control.setAttribute('aria-controls', DIALOG_ID);
        control.setAttribute('aria-expanded', 'false');
        controls.push(control);
      }
    });

    EventBus.on('search-modal-toggled', (isOpen) => {
      controls.forEach(control => control.setAttribute('aria-expanded', String(isOpen === true)));
    });
  }
}

export { init };
